module.exports = __webpack_public_path__ + "static/media/ifelse-settings.a1c261f1.svg";